var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 11.9607C13.8239 11.9607 15.3031 10.4989 15.3031 8.69568C15.3031 6.89246 13.8239 5.43066 11.9992 5.43066C10.1745 5.43066 8.69531 6.89246 8.69531 8.69568C8.69531 10.4989 10.1745 11.9607 11.9992 11.9607Z",
    stroke: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    stroke: "#1C274C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5685 20.8241C18.3934 17.6322 17.4191 15.3047 11.9995 15.3047C6.58005 15.3047 5.6058 17.6322 5.43066 20.8241",
    stroke: "#1C274C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.4bb3668b1ea9f433cf1ac4fcf4ce0b45.svg";
export { ForwardRef as ReactComponent };